/**
 * GA-Mapping Utilities
 * Stellt Funktionen bereit, um GA-Nummern zu vollständigen Titeln aufzulösen
 */

import gaMapping from '../data/ga_mapping.json';

export type GAMapping = Record<string, string>;

/**
 * Lädt das GA-Mapping (wird zur Build-Zeit eingebunden)
 */
export const getGAMapping = (): GAMapping => {
  return gaMapping as GAMapping;
};

/**
 * Holt den vollständigen Titel für eine GA-Nummer
 * @param gaNumber - Die GA-Nummer (z.B. "GA001" oder "001")
 * @returns Der vollständige Titel oder leerer String
 */
export const getGATitle = (gaNumber: string): string => {
  const mapping = getGAMapping();

  // Normalisiere GA-Nummer (füge GA-Präfix hinzu falls nicht vorhanden)
  const normalizedGA = gaNumber.startsWith('GA') ? gaNumber : `GA${gaNumber}`;

  return mapping[normalizedGA] || '';
};

/**
 * Formatiert GA-Nummer mit Titel
 * @param gaNumber - Die GA-Nummer (z.B. "GA001")
 * @param separator - Trennzeichen zwischen Nummer und Titel (Standard: " – ")
 * @returns Formatierter String "GA001 – Titel" oder nur "GA001" falls kein Titel
 */
export const formatGAWithTitle = (gaNumber: string, separator: string = ' – '): string => {
  const title = getGATitle(gaNumber);
  return title ? `${gaNumber}${separator}${title}` : gaNumber;
};

/**
 * Prüft ob eine GA-Nummer im Mapping existiert
 * @param gaNumber - Die GA-Nummer
 * @returns true wenn die Nummer existiert
 */
export const hasGATitle = (gaNumber: string): boolean => {
  const mapping = getGAMapping();
  const normalizedGA = gaNumber.startsWith('GA') ? gaNumber : `GA${gaNumber}`;
  return normalizedGA in mapping;
};
